import React from 'react';

// @ts-ignore
import HeaderAppTitle from "../common/app-title/app-title";
import AppNavigation from "../../../../core/gd-app/app-navigation";

type Props = {
    name           : string
    icon?          : any
    navigation?    : AppNavigation | any[]
    editable       : boolean
    onChange       : callback
    maxWidth?      : number
    withPadding?   : boolean
    noLeftPadding? : boolean
    className?     : string
}

export default function TopHeaderNavigationDeprecated(props:Props) {



    const onNavigation = (parent:any) => {
        gd.navigation.goTo(parent.href)
    }


    // This is support for old format
    // @ts-ignore
    const breadcrumbs : any[] = props.navigation?.breadcrumbs ? props.navigation.breadcrumbs : props.navigation


    return (
        <div className="ui5-app-header no-menu">
            <div className="left">
                {props.icon}

                {breadcrumbs && breadcrumbs.map((parent,key)=>(
                    <React.Fragment key={key}>
                        <div className="ui5-link-bigger" onClick={onNavigation.bind({}, parent)}>{parent.name}</div>
                        <div className="nav-separator">/</div>
                    </React.Fragment>
                ))}

                <HeaderAppTitle {...props} />
            </div>
        </div>
    );
}